import React from "react";

export default ({ assets = [] }) => {
    
    return (
        <div className="tw-font-sans tw-font-light tw-text-[14px] tw-mt-[55px] tw-mb-[15px]">
            1 - {assets.items.length} of {assets.total} Results
        </div>
    );
}

